import {DOMAIN_PROPERTIES} from "../constants";

export const getApiUrl = () => DOMAIN_PROPERTIES[window.location.host].apiUrl

